import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from './components/ScrollToTop';
import route from "./helper/route";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/fonts/font-jakarta.css';
import './assets/scss/global.scss';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DashboardProvider } from "./context/DashboardContext";

function App() {
  return (
    <>
      <BrowserRouter>
        <DashboardProvider>
          <ScrollToTop>
            <ToastContainer />
            <Routes>
              {route?.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
            </Routes>
          </ScrollToTop>
        </DashboardProvider>
      </BrowserRouter>
    </>
  );
}

export default App;